import { useMutation, useQueryClient } from '@tanstack/react-query'
import { transferOwnership } from '@/api/shares'
import { queryKeys } from '@/lib/queryKeys'

/**
 * Hook for transferring ownership of a plan
 */
export function useTransferOwnership(planId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      newOwnerId,
      keepAsEditor = true,
    }: {
      newOwnerId: string
      keepAsEditor?: boolean
    }) => transferOwnership(planId, newOwnerId, keepAsEditor),
    onSuccess: () => {
      // Invalidate relevant queries
      queryClient.invalidateQueries({
        queryKey: queryKeys.shares.byPlanId(planId),
      })
      queryClient.invalidateQueries({
        queryKey: queryKeys.planDetail.byId(planId),
      })
    },
  })
}
